// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stoper-export[data-v-8bb9da42] {\n    text-decoration: underline;\n    color: var(--color-cool-grey);\n    cursor: pointer;\n    margin: 15px 0;\n}\n.stoper-export--gate[data-v-8bb9da42] {\n    margin-right: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
